export const LOCALES = {
    ENGLISH: 'en-us',
    LAOS: 'lo-la',
    FRENCH: 'fr-ca',
  };
  